import { render, staticRenderFns } from "./add-result.vue?vue&type=template&id=01f9252f&scoped=true"
import script from "./add-result.vue?vue&type=script&lang=js"
export * from "./add-result.vue?vue&type=script&lang=js"
import style0 from "./add-result.vue?vue&type=style&index=0&id=01f9252f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9252f",
  null
  
)

export default component.exports